// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'My Account',
    profile: 'Profile',
    orders: 'Orders',
    change_password: 'Change Password'
}
